<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Team
    </h5>
    <div *ngIf="!hasCompany" class="dv-bsnss">
      <p>You don't have company information yet. Please update the company details first from account setting then try
        to add it's members. </p>
    </div>
    <div *ngIf="hasCompany">
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row dv-owners">
            <div class="col-lg-4 mat-crd-ui">
              Owners
              <br>
              <p> Owners have permission to see and do everything. They can also add and remove other owners </p>
            </div>

            <div class="col-lg-7 mat-crd-ui dv-team-area">
              <mat-tab-group>
                <mat-tab label="Active">
                  <div class="dv-not-avlble" *ngIf="companyMembers.length == 0">
                    Not available
                  </div>
                  <div class="dv-content" *ngIf="companyMembers.length > 0">
                    <div *ngFor="let list of companyMembers">
                      <div *ngIf="list.Role == 'StoreOwner'" class="row dv-owenrs-list">
                        <div class="col-lg-12 dv-owner">
                          <img _ngcontent-c3="" alt="dashboard" id="file-image" [src]="list.ProfileImage || 'assets/img/default_user_img.png'">&nbsp;&nbsp;&nbsp; {{list.Name}}
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <div *ngIf="loggedInUserRole == 'StoreAdmin' || loggedInUserRole == 'StoreOwner' " class="dv-invite-btn">
                    <button [routerLink]="[ '/store/team/invite/owner']" mat-stroked-button> Invite owner</button>
                  </div>
                </mat-tab>
                <mat-tab label="Invited">
                  <div class="dv-not-avlble" *ngIf="invitedMembers.length == 0">
                    Not available
                  </div>
                  <div class="dv-content" *ngIf="invitedMembers.length > 0">
                    <div *ngFor="let list of invitedMembers">
                      <div *ngIf="list.Role == 'Owner'">
                        <div class="row dv-owenrs-list">
                          <div class="col-lg-6 col-xs-12 dv-name">
                            <img _ngcontent-c3="" alt="dashboard" id="file-image"
                              src="assets/img/default_user_img.png">&nbsp;&nbsp;&nbsp;{{list.Email}}
                          </div>
                          <div class="col-lg-6 col-xs-12 dv-lgin"
                          *ngIf="loggedInUserRole == 'StoreAdmin' || loggedInUserRole == 'StoreOwner' ">
                          <small *ngIf="list.Expired">Link expired</small> &nbsp;
                          <button *ngIf="list.Expired" mat-stroked-button color="primary" (click)="sendInvite(list.Role,list.Email)">
                            Resend invitation
                          </button>
                        </div>
                        </div>                       
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row dv-owners">
            <div class="col-lg-4 mat-crd-ui">
              Staff members
              <br>
              <p> Staff members can only see or manage sensitive business information such as financial data if you give
                them access. </p>
            </div>

            <div class="col-lg-7 mat-crd-ui dv-team-area">
              <mat-tab-group>
                <mat-tab label="Active">
                  <div class="dv-not-avlble" *ngIf="companyMembers.length == 0">
                    Not available
                  </div>
                  <div class="dv-content" *ngIf="companyMembers.length > 0">
                    <div *ngFor="let list of companyMembers">
                      <div *ngIf="list.Role == 'StoreStaffMember'" class="row dv-owenrs-list">
                        <div class="col-lg-6 col-xs-12 dv-stff">
                          <img _ngcontent-c3="" alt="dashboard" id="file-image" [src]="list.ProfileImage || 'assets/img/default_user_img.png'">&nbsp;&nbsp;&nbsp; {{list.Name}}
                        </div>
                        <div class="col-lg-6 col-xs-12 dv-lgin"
                          *ngIf="loggedInUserRole == 'StoreAdmin' || loggedInUserRole == 'StoreOwner' ">

                          <button (click)="GetAllPermissions(list.UserId)" class="btn btn-sm btn-default special-btn">
                            <i class="fa fa-cog" aria-hidden="true"></i> Manage Access
                          </button>
                          <button (click)="deleteUser(list.UserId)" class="btn btn-link edit-button">
                            <i class="fa fa-trash"></i>
                          </button>
                          <mat-slide-toggle (change)="deactivateUser(list.UserId)"
                            checked="{{list.IsActive}}"></mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="loggedInUserRole == 'StoreAdmin' || loggedInUserRole == 'StoreOwner' " class="dv-invite-btn">
                    <button  [routerLink]="[ '/store/team/invite/member']" mat-stroked-button> Invite staff
                      member</button>
                  </div>
                </mat-tab>
                <mat-tab label="Invited">
                  <div class="dv-not-avlble" *ngIf="invitedMembers.length == 0">
                    Not available
                  </div>
                  <div class="dv-content" *ngIf="invitedMembers.length > 0">
                    <div *ngFor="let list of invitedMembers">
                      <div *ngIf="list.Role == 'Staff'" class="row dv-owenrs-list">
                        <div class="col-lg-6 dv-name">
                          <img _ngcontent-c3="" alt="dashboard" id="file-image"
                            src="assets/img/default_user_img.png">&nbsp;&nbsp;&nbsp; {{list.Email}}
                        </div>
                        <div class="col-lg-6 dv-lgin"
                          *ngIf="loggedInUserRole == 'StoreAdmin' || loggedInUserRole == 'StoreOwner' ">
                          <small *ngIf="list.Expired">Link expired</small> &nbsp;
                          <button *ngIf="list.Expired" mat-stroked-button color="primary" (click)="sendInvite(list.Role,list.Email)">
                            Resend invitation
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>